import styled from "styled-components";

import { adminRoutePaths } from "@pages/AdminDashboard/adminRoutes";
import { useIsPhoneLayout } from "@pages/AdminDashboard/theme/AdminLayout";
import { adminTokens } from "@pages/AdminDashboard/theme/adminTokens";
import { ButtonLink } from "@pages/AdminDashboard/ui/Button";

const [, spaceSm] = adminTokens.spacing;
const smallButtonHeight = 30;

// On a phone the two Buttons share the card's width equally (FIND-R22).
const OpenInRow = styled.div<{ $isPhone: boolean }>`
  display: ${({ $isPhone }) => ($isPhone ? "flex" : "inline-flex")};
  gap: ${spaceSm - 2}px;
  min-height: ${smallButtonHeight}px;

  ${({ $isPhone }) => $isPhone && "& > * { flex: 1; }"}
`;

const openInAddress = (path: string, caseId: string | null | undefined) =>
  `${path}?case=${encodeURIComponent(caseId ?? "")}`;

interface OpenInButtonsProps {
  caseId: string | null | undefined;
}

// The secondary Buttons "Redo" and "Ship" that open a Case on those screens (CVIEW-R7, FIND-R22).
export const OpenInButtons = ({ caseId }: OpenInButtonsProps) => {
  const isPhone = useIsPhoneLayout();

  return (
    <OpenInRow $isPhone={isPhone}>
      <ButtonLink look="secondary" to={openInAddress(adminRoutePaths.redo, caseId)}>
        Redo
      </ButtonLink>
      <ButtonLink look="secondary" to={openInAddress(adminRoutePaths.ship, caseId)}>
        Ship
      </ButtonLink>
    </OpenInRow>
  );
};
